export const AutomaticDeliverySelection = 'automatic_delivery_selection';
